import LinearGradient from "./LinearGradient.js";
/**
 * All props pass through to `<LinearGradient {...props} />`
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function GradientDarkgreenGreen(_ref) {
  let {
    from = '#184E86',
    to = '#57CA85',
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx(LinearGradient, {
    from: from,
    to: to,
    ...restProps
  });
}